/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：805
 */

"use strict"

import /* 0 */"react"
import * as /* [auto-meaningful-name] */React from "react"
import /* [auto-meaningful-name] */React1 from /* 0 */"react"
var _a
_a = React1.createContext(null)
export { _a as a }
export default _a
